module.exports = __webpack_public_path__ + "static/alps2alps-skin-145a1a636bcd12135ac6e3c6d6fe003d.png";